export default {
  "HitPaw Online Audio Joiner": "HitPaw Online Audio Joiner",
  "Merge Audio": "Merge Audio",
  "Merge multiple audio tracks into one.": "Merge multiple audio tracks into one.",
  "Merge New": "Merge New",
  "Merge failed": "Merge failed",
  "Fade in": "Fade in",
  "Fade out": "Fade out",
  "Add tracks": "Add tracks",
  "Format": "Format",
};
